<template>
  <div class="Inquiry-action-comments">
    <article class="Chat">
      <div class="Chat__entries" v-if="action.messages.length">
        <ApplicationActionCommentsEntry
          v-for="(messageEntry, i) in action.messages"
          :key="messageEntry.postedAt"
          :message-entry="messageEntry"
          :i="i"
          :action-id="action.id"
          :disabled="disabled"
        />
      </div>
      <div v-if="!disabled" class="Chat__formwrap">
        <form @submit.prevent="onChatSubmit">
          <div class="Chat-form">
            <div class="Chat-form__field">
              <TextAreaInput
                v-model="message"
                placeholder="Skriv ett meddelande här..."
              />
            </div>
            <div class="Chat-form__button">
              <button
                :disabled="!message || isSubmitLoading"
                class="Button Button--primary Button--block"
              >
                Skicka
              </button>
            </div>
          </div>
        </form>
      </div>
    </article>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { EventBus } from "@/services/event-bus";
import TextAreaInput from "@/components/forms/TextAreaInput";
import ApplicationActionCommentsEntry from "./ApplicationActionCommentsEntry";

export default {
  name: "ApplicationActionComments",
  components: {
    TextAreaInput,
    ApplicationActionCommentsEntry
  },
  props: {
    action: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      message: "",
      isSubmitLoading: false
    };
  },
  methods: {
    ...mapActions("applicationStore", ["postActionMessage"]),
    onChatSubmit() {
      if (!this.message) return;
      this.isSubmitLoading = true;

      const args = {
        actionId: this.action.id,
        message: this.message
      };

      this.postActionMessage(args)
        .then(result => {
          this.message = "";
          this.isSubmitLoading = false;
          EventBus.$emit("expander:resize");
        })
        .catch(e => {
          this.isSubmitLoading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.Chat {
  &__entries {
    @include clearfix;
    margin-top: $spacing;
  }
  &__formwrap {
    margin-top: $spacing;
  }
}

.Chat-form {
  display: flex;
  flex-direction: column;
  @include media-from($alpha-width) {
    flex-direction: row;
  }
  &__field {
    flex: 1 0 auto;
    @include media-from($alpha-width) {
      padding-right: $gutter/2;
    }
  }
  &__button {
    flex: 0 0 auto;
    margin-top: $spacing;
    @include media-from($alpha-width) {
      margin-top: 0;
    }
  }
}
</style>
